import { useMemo } from "react";
import { getElementScrollableHeight } from "client/services/hooks/use-element-size";
import { Rect } from "react-konva";
import Shapes from "segments/desktop/shape";
import { getShapeProps } from "components/templates/dynamic-template/segments-layout-list/canvas/helpers";

const Rectangle = (props) => {
  const shapeProps = getShapeProps(props, Shapes.RectangleShapeComponent.type);

  const windowHeight = props.windowHeight;
  const relativeTo = props.relativeTo;
  const isPreview = props.isPreview;

  const relativeToElementY = useMemo(() => {
    if (relativeTo) {
      const relativeElement = document.getElementById(relativeTo);

      if (relativeElement) {
        const elementY = getElementScrollableHeight(isPreview ? relativeElement.offsetParent || relativeElement : relativeElement);
        return elementY;
      }
    }

    return 0;
  }, [windowHeight, relativeTo, isPreview]);

  return <Rect {...shapeProps} y={shapeProps.y + relativeToElementY} />;
};

export default Rectangle;
